// extracted by mini-css-extract-plugin
export default {"container":"CorpItKnowledge_container__1Go-c","header":"CorpItKnowledge_header__XBHeW","content":"CorpItKnowledge_content__4ZNJ9","comingSoon":"CorpItKnowledge_comingSoon__2ouFQ"};